import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { z_index_default } from "./chunk-7OKLMD4V.mjs";
import { breakpoints_default } from "./chunk-DDAHWWWN.mjs";
import { colors_default } from "./chunk-C7H5GWRZ.mjs";
import { radius_default } from "./chunk-4REDROSM.mjs";
import { shadows_default } from "./chunk-DJNGX4VH.mjs";
import { transition_default } from "./chunk-AU77DZXY.mjs";
import { blur_default } from "./chunk-OLDNEXT6.mjs";
import { borders_default } from "./chunk-ZV5E32CG.mjs";
import { typography_default } from "./chunk-HOOF7HHD.mjs";
import { sizes_default } from "./chunk-X4JBRTE2.mjs";
import { spacing } from "./chunk-G3IFUAY5.mjs";

// src/foundations/index.ts
var foundations = _objectSpread(_objectSpread({
  breakpoints: breakpoints_default,
  zIndices: z_index_default,
  radii: radius_default,
  blur: blur_default,
  colors: colors_default
}, typography_default), {}, {
  sizes: sizes_default,
  shadows: shadows_default,
  space: spacing,
  borders: borders_default,
  transition: transition_default
});
export { foundations };